import {
  Divider,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography
} from '@material-ui/core';
import {AddCircle, Edit, Delete, VisibilityOff, Visibility, Fingerprint, Check} from '@material-ui/icons';
import React, {RefObject, useEffect, useRef, useState} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Group from '../../../Domain/Models/Group';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import PlayerPair from "../../../Domain/Models/PlayerPair";
import PlayerPairModal from './PlayerPairModal';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));


export interface PlayerPairContentProps
{
  group: Group;
  reload: () => void;
  errorCardControllerRef: RefObject<ErrorCardController>;
}

export default function PlayerPairContent(props: PlayerPairContentProps)
{
  const classes = useStyles();
  const history = useHistory();

  const {group, reload, errorCardControllerRef} = props;

  const [idVisible, setIdVisible] = useState(false);
  const [playerPairToEdit, setPlayerPairToEdit] = useState<PlayerPair | undefined>(undefined);
  const [playerPairDialogOpen, setPlayerPairDialogOpen] = useState(false);
  
  const handlePairClicked = (playerPair: PlayerPair) =>
  {
    history.push(`/scoreCards/${playerPair.id}`);
  }

  const handleEditPlayerPairClicked = (playerPair: PlayerPair) =>
  {
    setPlayerPairToEdit(playerPair);
    setPlayerPairDialogOpen(true);
  }

  const handleDialogClose = () =>
  {
    setPlayerPairToEdit(undefined);
    setPlayerPairDialogOpen(false);

    reload();
  }

  useEffect(() =>
  {

  }, []);

  return (
    <>
      {playerPairToEdit && (
        <PlayerPairModal
          open={playerPairDialogOpen}
          onClose={handleDialogClose}
          playerPair={playerPairToEdit}
        />
      )}

      <Paper className={classes.paper}>
        <Toolbar>
          <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
            Player Pairs
          </Typography>
          <IconButton size="small" color="default" onClick={() => setIdVisible(!idVisible)}>
            {idVisible ? <VisibilityOff/> : <Visibility/>}
          </IconButton>
        </Toolbar>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {idVisible && <TableCell>Pair ID</TableCell>}
                <TableCell>#</TableCell>
                <TableCell>Team Name</TableCell>
                <TableCell>Player Names</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {group.playerPairs.map((row, index) => (
                  <TableRow key={index} hover>
                    {idVisible && <TableCell scope="row">{row.id}</TableCell>}
                    <TableCell
                      className={classes.clickableCell}
                      onClick={() => handlePairClicked(row)}
                    >
                      {index}
                    </TableCell>
                    <TableCell
                      className={classes.clickableCell}
                      onClick={() => handlePairClicked(row)}
                    >
                      {row.name}
                    </TableCell>
                    <TableCell
                      className={classes.clickableCell}
                      onClick={() => handlePairClicked(row)}
                    >
                      {row.players.map(x => `${x.name}, `)}
                    </TableCell>
                    <TableCell>
                      <IconButton size="small" color="default" onClick={() => handleEditPlayerPairClicked(row)}>
                        <Edit/>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

      </Paper>
    </>
  );
}